module.exports = __webpack_public_path__ + "media/images/file-icons/256/004-folder-1-6e7499daff4b180c4a5749e854dd3041.png";